(function () {
  'use strict';
  if (window.EnigmaProductCardLayout) return;
  var cardSelector = '[data-wishlist-added], .item-product, .mtg-catalog__card';
  var heartSelector = '[data-icon-wishlist][data-product-handle]';
  var badgeSelector = '.enigma-single-card-variant-viewer__condition, .enigma-single-variant-matrix__condition, .enigma-single-card-variant-viewer__language, .enigma-single-variant-matrix__language';
  var pending = new Set(), scheduled = false;
  var singleSelector = '.enigma-single-product-card';
  var singleScopeSelector = '.eh-track, .enigma-home-merch__grid, .mtg-catalog__grid, .enigma-single-product-card-grid, .wishlist-content, .slick-track, .owl-stage, .swiper-wrapper, #recently-viewed-products, #product-grid, .grid--view-items, .collection__product-content';
  var singleScheduled = false, singleObserved = new Set();
  var singleResizeObserver = typeof ResizeObserver === 'function' ? new ResizeObserver(queueSingleAlignment) : null;

  function queueSingleAlignment() {
    if (singleScheduled) return;
    singleScheduled = true;
    window.requestAnimationFrame(alignSingleActions);
  }
  function singleScope(card) {
    var scope = card.parentElement.closest(singleScopeSelector);
    if (scope) return scope;
    // Older grids wrap each card in a column: find their shared collection.
    scope = card.parentElement;
    while (scope.parentElement && scope.querySelectorAll(singleSelector).length < 2 && !scope.matches('section, main, body, .shopify-section')) scope = scope.parentElement;
    return scope;
  }
  function alignSingleActions() {
    singleScheduled = false;
    var groups = new Map(), measurements = [], watched = new Set();
    document.querySelectorAll(singleSelector).forEach(function (card) {
      var actions = card.querySelector('.enigma-single-product-card__actions');
      watched.add(card);
      card.querySelectorAll('.enigma-single-variant-matrix__list, .enigma-single-product-card__title, .enigma-single-product-card__edition, .enigma-single-product-card__actions').forEach(function (node) { watched.add(node); });
      var edition = card.querySelector('.enigma-single-product-card__edition');
      var variants = card.querySelector('.enigma-single-variant-matrix__fieldset');
      var previousEdition = edition ? parseFloat(edition.style.getPropertyValue('--single-edition-offset')) || 0 : 0;
      var previousVariants = variants ? parseFloat(variants.style.getPropertyValue('--single-variant-offset')) || 0 : 0;
      var item = {actions: actions, edition: edition, variants: variants, reserve: 0, editionReserve: 0, variantReserve: 0};
      measurements.push(item);
      var bounds = card.getBoundingClientRect(), actionBounds = actions && actions.getBoundingClientRect();
      if (!bounds.width || !bounds.height) return;
      // DOM rectangles include CSS zoom; offsets are written in local CSS pixels.
      var cardScale = parseFloat(getComputedStyle(card).zoom) || 1;
      var scope = singleScope(card), rows = groups.get(scope);
      if (!rows) { rows = []; groups.set(scope, rows); }
      var row = rows.find(function (candidate) { return Math.abs(candidate.top - bounds.top) < 2; });
      if (!row) { row = {top: bounds.top, items: []}; rows.push(row); }
      if (edition && edition.getBoundingClientRect().height) item.editionNatural = (edition.getBoundingClientRect().top - bounds.top) / cardScale - previousEdition;
      if (variants && variants.getBoundingClientRect().height) item.variantNatural = (variants.getBoundingClientRect().top - bounds.top) / cardScale - previousEdition - previousVariants;
      // Subtract our previous gap: extra space can shrink after filters/resize.
      // Content following the actions (including errors) never enters this sum.
      if (actionBounds && actionBounds.height) item.natural = (actionBounds.top - bounds.top) / cardScale - (parseFloat(getComputedStyle(actions).marginTop) || 0) - previousEdition - previousVariants;
      row.items.push(item);
    });
    groups.forEach(function (rows) {
      rows.forEach(function (row) {
        // Every game uses the same stages: heading/edition, variants, actions.
        // Edition text can wrap and the number of variants can differ per card.
        // Predict the resulting action positions so all three stages use one read/write batch.
        var editionMaximum = 0, variantMaximum = 0, actionMaximum = 0;
        row.items.forEach(function (item) { if (item.editionNatural !== undefined) editionMaximum = Math.max(editionMaximum, item.editionNatural); });
        row.items.forEach(function (item) {
          if (item.editionNatural !== undefined) item.editionReserve = gap(editionMaximum - item.editionNatural);
          if (item.variantNatural !== undefined) variantMaximum = Math.max(variantMaximum, item.variantNatural + item.editionReserve);
        });
        row.items.forEach(function (item) {
          if (item.variantNatural !== undefined) item.variantReserve = gap(variantMaximum - item.variantNatural - item.editionReserve);
          if (item.natural !== undefined) actionMaximum = Math.max(actionMaximum, item.natural + item.editionReserve + item.variantReserve);
        });
        row.items.forEach(function (item) {
          if (item.natural !== undefined) item.reserve = gap(actionMaximum - item.natural - item.editionReserve - item.variantReserve);
        });
      });
    });
    // Batch reads before writes and avoid resize/mutation feedback loops.
    measurements.forEach(function (item) {
      setOffset(item.edition, '--single-edition-offset', item.editionReserve);
      setOffset(item.variants, '--single-variant-offset', item.variantReserve);
      setOffset(item.actions, '--single-action-offset', item.reserve);
    });
    if (singleResizeObserver) {
      singleObserved.forEach(function (node) { if (!watched.has(node)) singleResizeObserver.unobserve(node); });
      watched.forEach(function (node) { if (!singleObserved.has(node)) singleResizeObserver.observe(node); });
      singleObserved = watched;
    }
  }
  function gap(value) { return Math.max(0, Math.round(value * 100) / 100); }
  function setOffset(node, property, value) {
    if (!node) return;
    var previous = parseFloat(node.style.getPropertyValue(property)) || 0;
    if (Math.abs(previous - value) < 0.1) return;
    if (value) node.style.setProperty(property, value + 'px');
    else node.style.removeProperty(property);
  }

  function move(node, parent, after) {
    if (!node || !parent || (node.parentElement === parent && (!after || after.nextSibling === node))) return;
    var active = document.activeElement, restore = active && node.contains(active);
    if (after) parent.insertBefore(node, after.nextSibling);
    else parent.appendChild(node);
    if (restore && active.focus) active.focus({preventScroll: true});
  }
  function addClass(node, name) {
    if (node && !node.classList.contains(name)) node.classList.add(name);
  }
  function nameAction(action) {
    if (!action) return;
    var label = (action.textContent || '').replace(/\s+/g, ' ').trim();
    if (label && (!action.hasAttribute('aria-label') || action.hasAttribute('data-enigma-card-managed-label'))) {
      if (action.getAttribute('aria-label') !== label) action.setAttribute('aria-label', label);
      action.setAttribute('data-enigma-card-managed-label', '');
    }
    addClass(action, 'enigma-card-layout__action');
  }
  function makeRow(parent, action) {
    var row = action.parentElement;
    if (!row.classList.contains('enigma-card-layout__actions')) {
      row = document.createElement('div');
      row.className = 'enigma-card-layout__actions';
      parent.insertBefore(row, action);
      move(action, row);
    }
    return row;
  }
  function layoutCard(card) {
    if (!card || !card.isConnected || card.closest('.enigma-home-product-card, .enigma-home-merch')) return;
    if (card.matches('.enigma-single-product-card') || card.querySelector('.enigma-single-product-card')) return;
    var wishlistPage = card.closest('[data-wishlist-added]');
    if (wishlistPage && wishlistPage !== card) { layoutCard(wishlistPage); return; }
    addClass(card, 'enigma-product-card-layout');
    var heart = card.querySelector(heartSelector), row, action;
    if (!heart) return;
    var heartNode = heart.closest('.productWishList') || heart;

    if (wishlistPage) {
      var info = card.querySelector('.item-product .product__info');
      action = card.querySelector('.enigma-wishlist-product-link');
      if (!info || !action) return;
      addClass(card, 'enigma-product-card-layout--wishlist');
      row = info.querySelector('.enigma-card-layout__actions');
      if (!row) {
        row = document.createElement('div'); row.className = 'enigma-card-layout__actions';
        info.appendChild(row);
      }
      move(action, row);
    } else if (card.matches('.mtg-catalog__card')) {
      row = card.querySelector('.mtg-catalog__buy');
      if (row) action = row.querySelector('button[type="submit"]');
      else {
        var offer = card.querySelector('.mtg-catalog__offer');
        action = offer && offer.querySelector('a[href]');
        if (action) row = makeRow(action.parentElement, action);
      }
    } else {
      var form = card.querySelector('form.form-btn-item-product');
      if (form && !form.classList.contains('hide')) {
        row = form; action = form.querySelector('.add-to-cart-btn');
      } else {
        action = card.querySelector('.item-product-popup:not(.hide) .btn-quick-add');
        if (action) row = makeRow(action.parentElement, action);
      }
    }
    if (!row || !action) return;
    addClass(row, 'enigma-card-layout__actions');
    nameAction(action);
    addClass(heartNode, 'enigma-card-layout__wishlist');
    addClass(heart, 'enigma-card-layout__heart');
    // Keep the same element, attributes and listeners used by the wishlist consent controller.
    if (!heart.getAttribute('aria-label') && !heart.getAttribute('title')) {
      var strings = window.theme && window.theme.strings;
      var label = strings && strings.addto_wishlist;
      if (label) heart.setAttribute('title', label);
    }
    move(heartNode, row, action);
    var hasQuantity = !!row.querySelector('[name="quantity"]:not([type="hidden"])');
    row.classList.toggle('enigma-card-layout__actions--quantity', hasQuantity);
    row.classList.toggle('enigma-card-layout__actions--plain', !hasQuantity);
  }
  function normalizeBadge(badge) {
    if (!badge || !badge.isConnected) return;
    if (badge.classList.contains('enigma-single-card-variant-viewer__condition') || badge.classList.contains('enigma-single-variant-matrix__condition')) {
      var value = badge.querySelector('span');
      if (!value) return;
      // Keep the compact renderer code; full names remain available to assistive
      // technology and tooltips. These are the existing storefront grades.
      var code = compactCondition(value.textContent) || compactCondition(badge.getAttribute('title')) || compactCondition((badge.getAttribute('aria-label') || '').split(':').slice(1).join(':'));
      if (code && value.textContent !== code) value.textContent = code;
      return;
    }
    var language = (badge.getAttribute('aria-label') || '') + ' ' + badge.textContent;
    if (!/japanese|giapponese|\bJP\b|🇯🇵/i.test(language)) return;
    var flag = badge.querySelector('.enigma-single-card-variant-viewer__flag, .enigma-single-variant-matrix__flag');
    if (!flag || flag.querySelector('[data-enigma-japanese-flag]')) return;
    flag.innerHTML = '<svg data-enigma-japanese-flag class="enigma-language-selector__flag" viewBox="0 0 30 20" width="22" height="15" aria-hidden="true" focusable="false"><rect width="30" height="20" fill="#fff"/><circle cx="15" cy="10" r="6" fill="#bc002d"/></svg>';
  }
  function compactCondition(value) {
    var key = String(value || '').trim().replace(/\s+/g, ' ').replace(/\s+\([A-Z]{1,4}\)$/i, '').toLowerCase();
    if (/^(nm|m|mt|ex|lp|gd|pl|po|dmg)$/.test(key)) return key.toUpperCase();
    if (key.indexOf('near mint') !== -1) return 'NM';
    if (key === 'mint') return 'M';
    if (key.indexOf('excellent') !== -1) return 'EX';
    if (key.indexOf('lightly played') !== -1 || key.indexOf('light played') !== -1) return 'LP';
    if (key === 'good') return 'GD';
    if (key === 'played') return 'PL';
    if (key === 'poor') return 'PO';
    if (key.indexOf('damaged') !== -1 || key.indexOf('danneggiat') !== -1) return 'DMG';
    return '';
  }
  function inspect(node) {
    if (!node || node.nodeType !== 1) return;
    queueSingleAlignment();
    if (node.matches(cardSelector)) layoutCard(node);
    var owner = node.closest(cardSelector);
    if (owner) layoutCard(owner);
    node.querySelectorAll(cardSelector).forEach(layoutCard);
    if (node.matches(badgeSelector)) normalizeBadge(node);
    var badge = node.closest(badgeSelector);
    if (badge) normalizeBadge(badge);
    node.querySelectorAll(badgeSelector).forEach(normalizeBadge);
  }
  function flush() {
    scheduled = false;
    var nodes = Array.from(pending); pending.clear();
    nodes.forEach(inspect);
  }
  function queue(node) {
    if (node && node.nodeType === 1) pending.add(node);
    if (!scheduled) { scheduled = true; window.requestAnimationFrame(flush); }
  }
  function start() {
    inspect(document.documentElement);
    var observer = new MutationObserver(function (records) {
      records.forEach(function (record) {
        // Observe insertion/text changes only: our class changes and disabled/selection changes do not loop.
        queue(record.target);
        record.addedNodes.forEach(function (node) { if (node.nodeType === 1) queue(node); });
      });
    });
    observer.observe(document.body, {childList: true, subtree: true});
    window.EnigmaProductCardLayout.observer = observer;
    // Filters/list toggles can change layout without inserting product nodes.
    var visibilityObserver = new MutationObserver(function (records) {
      if (records.some(function (record) {
        var node = record.target;
        if (record.attributeName === 'style' && node.matches('.enigma-single-product-card__actions, .enigma-single-product-card__edition, .enigma-single-variant-matrix__fieldset')) return false;
        return node.matches(singleSelector) || node.closest(singleSelector) || node.querySelector(singleSelector);
      })) queueSingleAlignment();
    });
    visibilityObserver.observe(document.body, {attributes: true, attributeFilter: ['class', 'hidden', 'style'], subtree: true});
    window.EnigmaProductCardLayout.visibilityObserver = visibilityObserver;
    window.addEventListener('resize', queueSingleAlignment, {passive: true});
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(queueSingleAlignment);
  }
  window.EnigmaProductCardLayout = {refresh: inspect};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
})();

/* Shared product arrows follow the image box, independently of card text/variants. */
(function () {
  'use strict';
  var arrowSelector = '[data-eh-prev], [data-eh-next], [data-enigma-home-prev], [data-enigma-home-next], [data-mtg-commerce-prev], [data-mtg-commerce-next], [data-tcg-commerce-prev], [data-tcg-commerce-next], #recently-viewed-products .arrow-prev, #recently-viewed-products .arrow-next, .ProductRelated .arrow-prev, .ProductRelated .arrow-next';
  var scopeSelector = '.eh-carousel, .enigma-home-merch__carousel, .enigma-product-carousel, #recently-viewed-products, .ProductRelated';
  var mediaSelector = '.enigma-home-product-card__media, .enigma-single-product-card__media, .item-product .product-top';
  var watched = new Set(), frame = 0;
  var observer = typeof ResizeObserver === 'function' ? new ResizeObserver(schedule) : null;

  function schedule() {
    if (!frame) frame = requestAnimationFrame(align);
  }
  function align() {
    frame = 0;
    var nextWatched = new Set(), writes = [];
    document.querySelectorAll(scopeSelector).forEach(function (scope) {
      nextWatched.add(scope);
      var bounds = scope.getBoundingClientRect();
      if (!bounds.width || !bounds.height) return;
      var media = Array.from(scope.querySelectorAll(mediaSelector)).find(function (node) {
        var rect = node.getBoundingClientRect();
        return rect.width && rect.height && rect.right > bounds.left && rect.left < bounds.right;
      });
      if (!media) return;
      nextWatched.add(media);
      var rect = media.getBoundingClientRect();
      scope.querySelectorAll(arrowSelector).forEach(function (arrow) {
        var parent = arrow.offsetParent;
        if (!parent) return;
        var parentRect = parent.getBoundingClientRect();
        // Account for CSS zoom and borders on the absolute positioning container.
        var scale = parent.offsetHeight ? parentRect.height / parent.offsetHeight : 1;
        if (!scale) return;
        var center = (rect.top + rect.height / 2 - parentRect.top) / scale - parent.clientTop + parent.scrollTop;
        writes.push([arrow, center.toFixed(2) + 'px']);
      });
    });
    writes.forEach(function (entry) {
      if (entry[0].style.getPropertyValue('--enigma-carousel-image-center') !== entry[1]) {
        entry[0].style.setProperty('--enigma-carousel-image-center', entry[1]);
      }
    });
    if (observer) {
      watched.forEach(function (node) { if (!nextWatched.has(node)) observer.unobserve(node); });
      nextWatched.forEach(function (node) { if (!watched.has(node)) observer.observe(node); });
      watched = nextWatched;
    }
  }
  function start() {
    schedule();
    new MutationObserver(function (records) {
      if (records.some(function (record) {
        var target = record.target;
        return target.nodeType === 1 && (target.closest(scopeSelector) ||
          (record.type === 'attributes' && target.querySelector(scopeSelector)) ||
          Array.from(record.addedNodes).some(function (node) {
            return node.nodeType === 1 && (node.matches(scopeSelector) || node.querySelector(scopeSelector));
          }));
      })) schedule();
    }).observe(document.body, {childList: true, subtree: true, attributes: true, attributeFilter: ['hidden', 'class']});
    document.addEventListener('load', function (event) {
      if (event.target instanceof Element && event.target.closest(scopeSelector)) schedule();
    }, true);
    document.addEventListener('scroll', function (event) {
      if (event.target instanceof Element && event.target.closest(scopeSelector)) schedule();
    }, true);
    window.addEventListener('resize', schedule, {passive: true});
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedule);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
})();
